import React from 'react';
import HelmetBuilder from '../components/helmet-builder';
import Hero from '../components/hero';
import AboutMain from '../components/main';
import AboutContact from '../components/about-contact';
import FromTheBlog from '../components/from-the-blog';

import './about.scss';

const IndexPage = ({ data, location }) => (
  <div className="about">
    <HelmetBuilder
      data={data.about.edges[0].node}
      pathname={location.pathname}
    />
    <Hero title="About Us" />
    <AboutMain data={data.about.edges[0].node} />
    <AboutContact />
    <FromTheBlog data={data.fromTheBlog} />
  </div>
);

export default IndexPage;

export const pageQuery = graphql`
  query AboutUsPage {
    about: allContentfulAboutUsPage {
      edges {
        node {
          mainHeading
          mainText {
            mainText
          }
          mainVideoUrl
          metadata {
            title
            description
            ogimage {
              file {
                url
              }
            }
            keywords
          }
        }
      }
    }
    fromTheBlog: allContentfulBlogPost(
      sort: { fields: [postDate], order: DESC }
      limit: 2
    ) {
      edges {
        node {
          id
          title
          slug
          category {
            title
          }
          heroImage {
            file {
              url
            }
          }
          introductoryQuote {
            introductoryQuote
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/about.js